import { useMemo } from 'react';

import { useBetSlice, useGameStateSlice } from '@pp/core';

import { BetIds, Bets } from '../../../config/bets';
import { useMWStateSlice } from '../../../store/slices/mwState/selectors';

export const useBetSpotValueConnected = (betSpot: Bets, options?: { raw?: boolean }) => {
  const bets = useBetSlice.bets();
  const winResult = useGameStateSlice.winResult();
  const winResultFormMW = useMWStateSlice.getWinningAmount();
  const gameResult = useMWStateSlice.getGameResult();
  const isBetsOpenStatus = useGameStateSlice.isBetsOpenStatus();
  // Due some sort of order of round end handling, sometimes game result got displayed for a moment on bets open
  // Too risky to change that at this point, so maybe in MW 3.0

  return useMemo(() => {
    if (gameResult) {
      if (gameResult.betSpot === betSpot && (winResultFormMW || winResult) && !isBetsOpenStatus && !options?.raw) {
        return winResultFormMW?.winingAmount ?? winResult?.amount ?? 0;
      } else {
        return 0;
      }
    } else {
      const values: Record<Bets, number> = {} as Record<Bets, number>;
      BetIds.forEach((betId) => {
        values[betId] = bets?.betSpots?.[betId]?.value || 0;
      });
      return values[betSpot];
    }
  }, [gameResult, betSpot, winResult, winResultFormMW, isBetsOpenStatus, options?.raw, bets?.betSpots]);
};
